import AxiosClient from "../../../services/axios.services";

class DisciplinaryMeasurementServices {
  getDisciplinaryMeasurement = (params) =>
    AxiosClient.get(
      "/api/app/sanciones_mantenimiento_medidas_disciplinarias/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  saveDisciplinaryMeasurement = (data) =>
    AxiosClient.post(
      "/api/app/sanciones_mantenimiento_medidas_disciplinarias/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editDisciplinaryMeasurement = (id, data) =>
    AxiosClient.put(
      `/api/app/sanciones_mantenimiento_medidas_disciplinarias/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteDisciplinaryMeasurement = (id) =>
    AxiosClient.delete(
      `/api/app/sanciones_mantenimiento_medidas_disciplinarias/${id}`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new DisciplinaryMeasurementServices();
